// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DragDrop = require("../../../reason/settings/components/dragDrop/DragDrop.bs.js");
let Belt_Array = require("@rescript/runtime/lib/js/Belt_Array.js");
let Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
let ContentBox__Jsx3 = require("../../../uikit/reason/atoms/ContentBox/ContentBox__Jsx3.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let InitialUploadPrompt = require("../../../reason/settings/components/avatarField/InitialUploadPrompt.bs.js");
let AttachmentFormSection = require("../../common/Components/AttachmentFormSection.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function addAttachments(addImages, addFiles, files) {
  let match = Belt_Array.partition(files, file => Attachments.Attachment.ContentType.isImage(file.type));
  let files$1 = match[1];
  let images = match[0];
  if (images.length !== 0) {
    addImages(images);
  }
  if (files$1.length !== 0) {
    return addFiles(files$1);
  }
}

function WizardPhotosAndFiles(props) {
  let __fullWidth = props.fullWidth;
  let filesManager = props.filesManager;
  let imagesManager = props.imagesManager;
  let fullWidth = __fullWidth !== undefined ? __fullWidth : false;
  let add = extra => addAttachments(imagesManager.add, filesManager.add, extra);
  let widthLg = fullWidth ? 12 : 9;
  let match = imagesManager.attachments.concat(filesManager.attachments);
  return JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
    children: JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
      width: 12,
      widthLg: widthLg,
      children: JsxRuntime.jsx(ContentBox__Jsx3.make, {
        children: JsxRuntime.jsx(DragDrop.DragDropContext.make, {
          children: JsxRuntime.jsx(DragDrop.DropArea.make, {
            onChange: add,
            children: match.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  JsxRuntime.jsx(AttachmentFormSection.ImageUploadList.make, {
                    onAddAttachments: add,
                    onDeleteAttachment: imagesManager.delete,
                    reorder: imagesManager.reorder,
                    uploads: imagesManager.attachments
                  }),
                  JsxRuntime.jsx(AttachmentFormSection.FileUploadList.make, {
                    onAddAttachments: add,
                    onDeleteAttachment: filesManager.delete,
                    reorder: filesManager.reorder,
                    uploads: filesManager.attachments
                  })
                ]
              }) : JsxRuntime.jsx(InitialUploadPrompt.make, {
                onAddAttachments: add
              })
          })
        })
      })
    })
  });
}

let Cell;

let Grid;

let ContentBox;

let make = WizardPhotosAndFiles;

exports.Cell = Cell;
exports.Grid = Grid;
exports.ContentBox = ContentBox;
exports.addAttachments = addAttachments;
exports.make = make;
/* DragDrop Not a pure module */
